module.exports = {
  'head-length': 0.3,
  'neck-length': 0.08,
  'neck-height': 1.65,
  'shoulder-height': 1.55,
  'spine-chest-length': 0.18,
  'pelvis-spine-length': 0.18,
  'pelvis-center-height': 1.1,
  'hip-height': 1.0,
  'shoulder-space': 0.4,
  'upper-arm-length': 0.3,
  'lower-arm-length': 0.32,
  'hand-length': 0.25,
  'hip-space': 0.3,
  'upper-leg-length': 0.35,
  'ankle-height': 0.05,
  'foot-length': 0.3
}
